import React, { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Clés des nationalités pour traduction
const NATIONALITY_KEYS = [
  'afghan', 'albanian', 'german', 'andorran', 'angolan', 'antiguanBarbudan', 'algerian',
  'argentine', 'armenian', 'australian', 'austrian', 'azerbaijani', 'bahamian',
  'bahraini', 'bangladeshi', 'barbadian', 'belgian', 'belizean', 'beninese',
  'belarusian', 'burmese', 'bissauGuinean', 'bolivian', 'bosnian', 'motswana',
  'brazilian', 'britishOverseas', 'bruneian', 'bulgarian', 'burkinabe', 'burundian',
  'bhutanese', 'capeVerdean', 'cambodian', 'cameroonian', 'canadian', 'qatari',
  'centralAfrican', 'chadian', 'czech', 'chilean', 'chinese', 'cypriot',
  'colombian', 'comoran', 'congolese', 'congoleseDRC', 'costaRican', 'croatian',
  'cuban', 'danish', 'dominican', 'dominiquais', 'ecuadorian', 'egyptian',
  'emirati', 'eritrean', 'slovak', 'slovenian', 'spanish', 'american',
  'estonian', 'ethiopian', 'filipino', 'finnish', 'fijian', 'french',
  'gabonese', 'gambian', 'georgian', 'ghanaian', 'grenadian', 'greek',
  'guatemalan', 'guinean', 'guyanese', 'haitian', 'dutch', 'honduran',
  'hungarian', 'indian', 'english', 'indonesian', 'iranian', 'iraqi',
  'irish', 'icelandic', 'israeli', 'italian', 'jamaican', 'japanese',
  'jordanian', 'kazakh', 'kenyan', 'kosovar', 'kyrgyz', 'iKiribati', 'kuwaiti',
  'laotian', 'basotho', 'latvian', 'lebanese', 'liberian', 'libyan',
  'liechtensteiner', 'lithuanian', 'luxembourger', 'macedonian', 'malaysian',
  'malawian', 'malagasy', 'malian', 'maltese', 'ivorian', 'moroccan',
  'mauritian', 'mauritanian', 'mexican', 'micronesian', 'moldovan', 'monegasque',
  'mongolian', 'montenegrin', 'mozambican', 'namibian', 'newZealander', 'nepali',
  'nicaraguan', 'nigerien', 'nigerian', 'northKorean', 'norwegian', 'omani',
  'pakistani', 'palauan', 'panamanian', 'papuaNewGuinean', 'paraguayan', 'peruvian',
  'polish', 'portuguese', 'puertoRican', 'qatariNat', 'reunionese', 'romanian',
  'russian', 'rwandan', 'samoan', 'kittitian', 'sanMarinese', 'vincentian',
  'saoTomean', 'saudi', 'senegalese', 'serbian', 'seychellois', 'sierraLeonean',
  'singaporean', 'syrian', 'somali', 'sriLankan', 'swazi', 'southAfrican',
  'sudanese', 'southKorean', 'swedish', 'swiss', 'surinamese', 'southSudanese',
  'thai', 'tanzanian', 'tajik', 'timorese', 'togolese', 'tongan',
  'trinidadian', 'tunisian', 'turkmen', 'turkish', 'tuvaluan', 'ukrainian',
  'ugandan', 'uruguayan', 'uzbek', 'niVanuatu', 'venezuelan', 'vietnamese',
  'usVirginIslander', 'britishVirginIslander', 'yemeni', 'djiboutian', 'zambian', 'zimbabwean'
];

function NationalitiesSelect({ value, onChange }) {
  const { t, i18n } = useTranslation();

  const sortedNationalities = useMemo(() => {
    return NATIONALITY_KEYS
      .map(key => ({
        key,
        label: t(`createPlayer.nationalities.${key}`)
      }))
      .sort((a, b) => a.label.localeCompare(b.label, i18n.language));
  }, [t, i18n.language]);

  const selectedOption = useMemo(() => {
    if (!value) return null;
    const found = sortedNationalities.find(n => n.key === value);
    if (found) return found;
    // Ancienne valeur en base
    return { key: value, label: value };
  }, [value, sortedNationalities]);

  return (
    <Autocomplete
      options={sortedNationalities}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, val) => option.key === val.key}
      value={selectedOption}
      onChange={(_, newValue) => {
        onChange({ target: { value: newValue ? newValue.key : '' } });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('createPlayer.fields.nationality')}
        />
      )}
      fullWidth
    />
  );
}

export default NationalitiesSelect;
